module.exports = __webpack_public_path__ + "img/SPHYNX_FINAL.a84a8b06.jpg";